import axios from "axios";

export const state = {
    services: [],
};

export const getters = {
    services: state => state.services,
};

export const mutations = {
    setServices(services, newValue) { state.services = newValue},
};

export const actions = {
    fetchServices({ commit }) {
        axios.get('/services').then(res => {
            commit('setServices', res.data.services)
        })
    },
};
